import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface Options {
	enabled?: boolean;
}

export const fetchUserById = async (id?: number | string | null) => {
	if (!id) return Promise.reject("No id");

	const url = `/store/user/${id}/`;

	const { data } = await cmsClient.get<StoreUser>(url);

	return data;
};

const useSingleStoreUser = (
	id?: number | string | null,
	options: Options = { enabled: true }
) => {
	const query = useQuery(["user", id], () => fetchUserById(id), {
		enabled: options.enabled
	});

	return query;
};

export default useSingleStoreUser;
